import styled from 'styled-components'
import {
  AuthCard,
  AuthForm,
  AuthLogoContainer,
  AuthPageContainer,
} from '../../style/auth'

export const Container = AuthPageContainer

export const LoginContainer = AuthCard

export const LogoContainer = AuthLogoContainer

export const Form = styled(AuthForm)`
  margin-top: 1.5rem;
`
